import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/cross-browser.svg
 */
const IconCrossBrowser: IconComponent = ({
  size = 24,
  color = '#E2E2E2',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M20.927 1.522H3.08a3.086 3.086 0 00-2.18.902A3.075 3.075 0 000 4.602V19.4a3.076 3.076 0 003.079 3.079h17.84a3.086 3.086 0 002.18-.902A3.077 3.077 0 0024 19.4V4.602a3.08 3.08 0 00-3.073-3.08zm-17.84 1.68h17.84a1.397 1.397 0 011.396 1.396V8.62H1.683V4.598a1.396 1.396 0 011.396-1.395h.007zM20.926 20.8H3.08a1.402 1.402 0 01-1.291-.862 1.395 1.395 0 01-.106-.534v-9.095h20.643v9.095a1.394 1.394 0 01-1.398 1.396z"
      fill="currentColor"
    />
    <path
      d="M10.738 6.927a1.268 1.268 0 100-2.536 1.268 1.268 0 000 2.536zM7.186 6.927a1.268 1.268 0 100-2.536 1.268 1.268 0 000 2.536zM3.891 6.927a1.268 1.268 0 100-2.536 1.268 1.268 0 000 2.536z"
      fill="currentColor"
    />
  </svg>
);

export default IconCrossBrowser;
